import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'unitTimeLabel',
  standalone: true,
  pure: false,
})
@Injectable({
  providedIn: 'root',
})
export class UnitTimeLabelPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: number, unitType: string, showValue: boolean = false): string {
    if (!value) {
      return '';
    }

    const unit = this.getUnitForm(value);
    const translationKey = `${unitType}.${unit}`;
    const translation = this.translate.instant(translationKey);

    return showValue ? `${value} ${translation}` : translation;
  }

  private getUnitForm(value: number): string {
    const mod10 = value % 10;
    const mod100 = value % 100;

    if (mod100 >= 11 && mod100 <= 19) {
      return 'MANY';
    } else if (mod10 === 1) {
      return 'ONE';
    } else if (mod10 >= 2 && mod10 <= 4) {
      return 'FEW';
    } else {
      return 'MANY';
    }
  }
}
